import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledCsvEnrichmentContent = styled.div`
    display: flex;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon[400])};
    padding: 0 8px 16px 56px;
`;

export const StyledCsvEnrichmentEmptyWrapper = styled.div`
    padding: 24px 64px;
`;

export const StyledCsvEnrichmentDescription = styled(StyledCsvEnrichmentContent)`
    padding: 0 0 24px 0;
`;

export const StyledCsvEnrichmentHeaderContainer = styled(FlexRow)`
    [class*="StyledHomePageEnrichmentButton"] {
        font-weight: 500;

        [class*="IconWrapper"] {
            width: 16px;
            height: 16px;
            margin-left: 4px;
        }
    }
`;

export const StyledCsvEnrichmentIconButtonWrapper = styled.div`
    display: flex;
    margin-left: 8px;
`;
